import DocuSignService from '@/services/feature/docuSign.service';
// import moment from 'moment';

export const docuSign = {
  namespaced: true,
  state: {
  },
  getters: {
  },
  actions: {
    // patchOne({ commit }, { fileDataId, docPackageId }){
    //   return DocuSignService.patchOne(fileDataId, docPackageId).then(
    //     resp => {
    //       commit('dummy', "patchOne - success");
    //       return Promise.resolve(resp);
    //     },
    //     error => {
    //       commit('dummy', "patchOne - error");
    //       return Promise.reject(error.response);
    //     }
    //   );
    // },

    patch({ commit }, fileDataId){
      return DocuSignService.patch(fileDataId).then(
        resp => {
          commit('dummy', "patch - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummy', "patch - error");
          return Promise.reject(error.response);
        }
      );
    },

    cancel({ commit }, docusignEnvelopeId){
      return DocuSignService.cancel(docusignEnvelopeId).then(
        resp => {
          commit('dummy', "cancel - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummy', "cancel - error");
          return Promise.reject(error.response);
        }
      );
    },

    getDocuSignApiSettings({ commit }){
      return DocuSignService.getDocuSignApiSettings().then(
        resp => {
          commit('dummy', "getDocuSignApiSettings - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummy', "getDocuSignApiSettings - error");
          return Promise.reject(error.response);
        }
      );
    },

    resend({ commit }, { fileDataId, docPackageId}){
      return DocuSignService.resend(fileDataId, docPackageId).then(
        resp => {
          commit('dummy', "resend - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummy', "resend - error");
          return Promise.reject(error.response);
        }
      );
    },

    getSignedDocuments({ commit }, { fileDataId, docPackageId}){
      return DocuSignService.getSignedDocuments(fileDataId, docPackageId).then(
        resp => {
          commit('dummy', "getSignedDocuments - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummy', "getSignedDocuments - error");
          return Promise.reject(error.response);
        }
      );
    },

    getAuditTrail({ commit }, { fileDataId, docPackageId}){
      return DocuSignService.getAuditTrail(fileDataId, docPackageId).then(
        resp => {
          commit('dummy', "getAuditTrail - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummy', "getAuditTrail - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    }
  }
};